/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  let attemptCount = 0;
  let intervalId;
  
  function addPrivacyPolicyAriaLabel() {
    attemptCount++;
    const policyLink = document.getElementById('shopify-pc__banner__body-policy-link');
    
    if (policyLink) {
      if (!policyLink.hasAttribute('aria-label')) {
        policyLink.setAttribute('aria-label', 'Open Privacy Policy Page');
        clearInterval(intervalId);
        return;
      } else {
        clearInterval(intervalId);
        return;
      }
    }
    
    // Stop after 5 attempts
    if (attemptCount >= 5) {
      clearInterval(intervalId);
    }
  }

  // Check when DOM loads and periodically for dynamic content
  document.addEventListener('DOMContentLoaded', addPrivacyPolicyAriaLabel);
  intervalId = setInterval(addPrivacyPolicyAriaLabel, 2000);

  // Function to add role="presentation" to small icon SVGs without a class
  function addSvgPresentationRole() {
    const svgs = document.querySelectorAll('svg:not([class])');
    
    svgs.forEach(svg => {
      if (!svg.hasAttribute('role')) {
        const viewBox = svg.getAttribute('viewBox');
        if (viewBox) {
          const viewBoxValues = viewBox.split(' ').map(val => parseFloat(val));
          if (viewBoxValues.length === 4) {
            const width = viewBoxValues[2];
            const height = viewBoxValues[3];
            // Only apply to small icons (max 24px width/height)
            if (width <= 24 && height <= 24) {
              svg.setAttribute('role', 'presentation');
            }
          }
        }
      }
    });
  }

  // Run SVG presentation role function on DOM load
  document.addEventListener('DOMContentLoaded', addSvgPresentationRole);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
